import React from "react";
import "./Home.scss";
import { Layout, Header, Hero, CardList, HowTo, SectionComments, SectionArticle, AdBlock, AdImage, Testimonials } from "../../components";
import data from "../../data/data.json";

const Home = () => {

    return (
        <Layout isHero>
            <Header />
            <CardList />
            <AdBlock>
                <AdImage
                    width="728px"
                    height="90px"
                />
            </AdBlock>
            <HowTo />
            <AdBlock>
                <AdImage
                    width="728px"
                    height="90px"
                />
            </AdBlock>
            <Testimonials data={data.Testimonials} />
            <SectionArticle />
            <AdBlock>
                <AdImage
                    width="728px"
                    height="90px"
                />
            </AdBlock>
            <div className="separator"></div>
        </Layout>
    )
}

export default Home;
